<template>
    <div class="admin-tab">
        <wb-datatable
                class="apps-table"
                v-bind="tableAppProps"
                @addEmit="openDialog"
                @editEmit="openDialog"
                @deleteEmit="openConfirmDialog"
                :searchKey="'Name'"
        ></wb-datatable>

        <md-dialog ref="dialog">
            <md-dialog-title>{{isNew ? 'Create app group' : 'Update app group'}}</md-dialog-title>

            <md-dialog-content>
                <form v-if="appGroup">
                    <md-input-container>
                        <label>Name</label>
                        <md-input v-model="appGroup.Name"></md-input>
                    </md-input-container>
                    <md-input-container>
                        <label>Category</label>
                        <md-input v-model="appGroup.Category"></md-input>
                    </md-input-container>
                    <md-input-container>
                        <label>Image</label>
                        <md-input v-model="appGroup.image"></md-input>
                    </md-input-container>
                </form>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="closeDialog(false)">Cancel</md-button>
                <md-button class="md-primary" @click="closeDialog(true)">{{isNew ? 'Create' : 'Update'}}</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog ref="confirmDialog">
            <md-dialog-title>Are you sure you would like to remove this app group?</md-dialog-title>

            <md-dialog-content>
                App group will permanently be removed from the database. <br>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="closeConfirmDialog(false)">Cancel</md-button>
                <md-button class="md-primary" @click="closeConfirmDialog(true)">Delete</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
    import wbDataTable from 'WBDataTable';
    import {mapActions, mapGetters} from 'vuex';
    import Multiselect from 'vue-multiselect';
    import managedata from "../../helpers/managedata";

    export default {
        name: "AdminAppGroups",
        components: {
            'wb-datatable': wbDataTable,
            'multiselect': Multiselect,
        },
        data: () => ({
            tableAppProps: {
                dataext: [],
                columns: null,
                hasControls: true,
                allowCreation: true,
                disableSearch: false,
                pagination: {
                    size: 50
                },
            },
            tableAppColumns: [
                {name: 'id', displayName: 'ID', visible: true, type: 'number', isEditable: false, width: '20px'},
                {name: 'Name', displayName: 'Name', visible: true, type: 'string', isEditable: false},
                {name: 'Category', displayName: 'Category', visible: true, type: 'string', isEditable: false},
                {name: 'image', displayName: 'Image URL', visible: true, type: 'string', isEditable: false},
            ],
            appGroup: null,
            isNew: true
        }),
        methods: {
            getAppGroups() {
                managedata.getAppGroups().then(res => {
                    this.tableAppProps.dataext = res.body;
                    this.tableAppProps.columns = this.tableAppColumns;
                })
            },
            openDialog(row) {
                this.isNew = !row;
                this.appGroup = this.isNew ? {} : row;
                this.$refs.dialog.open();
            },
            closeDialog(isSaved) {
                if (isSaved) {
                    if (this.isNew) {
                        managedata.createAppGroup(this.appGroup).then(res => {
                            this.getAppGroups();
                            this.$refs.dialog.close();
                        }).catch(err => {
                            console.log(err);
                        })
                    } else {
                        managedata.updateAppGroup(this.appGroup).then(res => {
                            this.getAppGroups();
                            this.$refs.dialog.close();
                        }).catch(err => {
                            console.log(err);
                        })
                    }
                } else {
                    this.$refs.dialog.close();
                }
            },
            openConfirmDialog(row) {
                this.appGroup = row;
                this.$refs.confirmDialog.open();
            },
            closeConfirmDialog(isSaved) {
                if (isSaved) {
                    managedata.deleteAppGroup(this.appGroup.id).then(res => {
                        this.getAppGroups();
                        this.$refs.confirmDialog.close();
                    })
                } else {
                    this.$refs.confirmDialog.close();
                }
            }
        },
        mounted() {
            this.getAppGroups();
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// AdminAppGroups.vue?74c194b6